import script from "./OverrideModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverrideModal.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=66831b9a&scoped=true&lang=css&external"
import "./OverrideModal.vue?vue&type=style&index=1&id=66831b9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66831b9a"]])

export default __exports__